import { SaleHorseNoteModel } from './sale-horse-note.model';

export class SaleHorse {
  checkbox: any;
  userHorseSaleID: number;
  horseId: number;
  saleId: number;
  saleHorseId: number;
  bookNumber: number;
  sessionNumber: number;
  lotNumber: number;
  lot: string;
  lotNumberSuffix: string;
  statusText: string;
  statusDetail: string;
  price: number;
  reservePrice: number;
  date: string;
  catalogReservePrice: number;
  buyer: string;
  ageCategoryId: number;
  horseSexId: number;
  horseColourId: number;
  noneCount: number;
  notesCount: number;
  highInterestCount: number;
  vetCount: number;
  heartScanCount: number;
  vetReportCount: number;
  inspectionCount: number;
  inspectionTotal: number;
  image: string;
  saleName: string;
  salesCompanyName: string;
  sireID: number;
  sireDisplay: string;
  sire: string;
  dam: string;
  horseAgeCategoryId: number;
  consignor: string;
  isCurrent: boolean;
  barn: string;
  box: string;
  estimatedSaleTime: string;
  profileViewCount: number;
  horseSiblingSaleInfo: string;
  eitherStatusId: number;
  shortListCount: number;
  coveringSire: string;
  breedingStatus: string;
  microchip: string;
  submittedBy: string;
  videoUrl: string;
  attachmentCount: number;
  accountNo: string;
  studyDate: string;
  viewerGuid: string;
  horseName: string;
  name: string;
  accessionCode: string;
  horseAgeCategoryName: string;
  scopeStatus: string;
  xrayReportStatus: string;
  xrayStatus: string;
  scopeStatusId: number;
  xrayReportStatusId: number;
  xrayStatusId: number;
  saleHorseNotes: SaleHorseNoteModel[];
  firstStudyId: number;
  submissionStatusId: number;
  submissionStatus: string;
  dob: Date;
  isHorseNamed: boolean;
  isSelected: boolean;
  saleResult: string;
  statusId: number;
  hidden: boolean = false;
}
export class SaleHorseStatus {
  userHorseSaleID: number;
  originalStatus: number;
  showOnStatement: boolean;
  isNonCurrent: boolean;
  catalogPrice: number;
  catalogStatusID: number;
  catalogPurchaser: string;
  horseId: number;
  saleId: number;  
  lotNumber: number;
  lot: string;  
  statusText: string;
  statusDetail: string;
  price: number;
  reservePrice: number;
  dateSold: string;
  catalogReservePrice: number;
  buyer: string;  
  eitherStatusId: number;
  status: number;
  saleResult: string;
}
export class SaleHorseFlat {
  saleHorseId: number;
  horseId: number;
  saleId: number;
  lotNumber: number;
  lot: string;
  lotNumberSuffix: string;
  horseName: string;
  dam: string;
}

export enum SaleHorseTableFields {
  LOT = 'lot',
  HORSE_NAME = 'horseName',
  HORSE_AGE_CATEGORY_NAME = 'horseAgeCategoryName',
  CONSINGOR = 'consignor',
  ACCESSION_CODE = 'accessionCode',
  STATUS_DETAIL = 'statusDetail',
  HORSE_XRAY_STATUS = 'xrayStatus',
  HORSE_SCOPE_STATUS = 'scopeStatus',
  HORSE_XRAY_REPORT_STATUS = 'xrayReportStatus',
}

export enum SaleHorseSubmissionsStatusIds {
  PENDING = 0,
  DRAFT = 1,
  APPROVED = 4,
  DENIED = 3,
  IN_REVIEW = 2,
}
